<template>
    <nav class="navbar navbar-expand-lg navbar-dark">
        <!-- Brand -->
        <a class="navbar-brand d-none d-sm-block" href="#">
            <img src="../../../public/img/icons/favicon-32x32.png" width="30" height="30"
                class="d-inline-block align-top" alt="Academic Dean's Office">
            Academic Counselling Check-In
        </a>
        <a class="navbar-brand d-block d-sm-none" href="#">
            <img src="../../../public/img/icons/favicon-32x32.png" width="30" height="30"
                class="d-inline-block align-top" alt="Academic Dean's Office">
            ADO
        </a>
        <!-- Mobile Navigation -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <!-- Navigation -->
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <a class="nav-link" href="#" data-toggle="modal" data-target="#signoutModal"><i
                            class="fas fa-sign-out-alt"></i> Sign Out</a>
                    <!-- Modal -->
                    <div class="modal fade" id="signoutModal" tabindex="-1" aria-labelledby="signoutModalLabel"
                        aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="signoutModalLabel">Sign Out</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    Are you sure you want to sign out?
                                </div>
                                <div class="modal-footer">
                                    <div class="w-100">
                                        <button v-if="!bool" type="button" class="btn btn-success btn-block"
                                            @click="logout()">Confirm</button>
                                        <button v-else type="button" class="btn btn-success btn-block" disabled><i
                                                class="fas fa-spinner fa-spin"></i></button>
                                        <button type="button" class="btn btn-secondary btn-block"
                                            data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
import auth from '../../js/auth';

export default {
    name: 'student-navbar',
    data() {
        return {
            bool: false
        }
    },
    methods: {
        logout() {
            // Destroy session and redirect
            this.bool = true;
            auth.destroy_session();
            location.reload();
        }
    }
}
</script>

<style scoped>
.navbar {
    background-color: #003f36;
}
</style>